import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import { observer } from 'mobx-react'
import CookieAcceptNotificationPc from './components/CookieAcceptNotificationPc/CookieAcceptNotificationPc'
import CookieAcceptNotificationMobile from './components/CookieAcceptNotificationMobile/CookieAcceptNotificationMobile'

function CookieAcceptNotification() {
  const isMobile = useIsMobile()
  return isMobile ? <CookieAcceptNotificationMobile /> : <CookieAcceptNotificationPc />
}

export default observer(CookieAcceptNotification)
